{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-6-deutsch-texte-bericht-vorgangsbeschreibung",
  "version": "2026.08.1",
  "title": "Deutsch 6: Texte verfassen – Der Unfall- und Sachbericht, Vorgangsbeschreibung und Textverständnis (Realschule 6 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Deutsch 6: Sachgerechtes Verfassen von Unfall- und Ereignisberichten (W-Fragen, Präteritum, sachlicher Stil, keine wörtliche Rede), Vorgangsbeschreibungen und Textverständnis.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T23:15:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/6/deutsch",
      "checked": "2026-08-15",
      "label": "Realschule Deutsch 6, Lernbereich Texte schreiben – Informieren"
    }
  ],
  "atoms": [
    {
      "id": "01K4D6B0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4D6B0000000000000000A01",
      "namespace": "deutsch-texte",
      "slug": "unfallbericht-sachbericht-w-fragen-praeteritum-stil",
      "title": "Der Sach- und Unfallbericht: Die 7 W-Fragen, Tempus Präteritum, sachlicher Stil und Verzicht auf Wertung",
      "domain": "schule/deutsch/texte",
      "reduction": "formal",
      "typical_age_min": 11.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q188",
          "target_label": "Report (text)",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 6,
          "subject": "deutsch",
          "topic_code": "lb1",
          "topic_title": "Texte schreiben – Informieren",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4D6B0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welches Tempus (Zeitform) muss beim Verfassen eines sachlichen Unfall- oder Polizeiberichts verbindlich als Grundzeit verwendet werden?",
          "concept": "Das Präteritum (einfache Vergangenheit; bei Vorzeitigkeit das Plusquamperfekt)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Das Präteritum (Vergangenheit)",
              "Das Präsens (Gegenwart)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4D6B0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre den Aufbau und die Merkmale eines normgerechten Berichts: 1. Die 7 W-Fragen der Einleitung (*Wer?, Was?, Wann?, Wo?*) und des Hauptteils (*Wie?, Warum?, Welche Folgen?*), 2. Sprachlicher Stil: strikte Sachlichkeit, Objektivität (keine Gefühlsäußerungen, keine Spannungselemente, keine wörtliche Rede), 3. Chronologische Abfolge der Ereignisse, 4. Tempus: Präteritum (bei Vorzeitigkeit Plusquamperfekt) und formuliere aus folgenden Stichpunkten einen vollständigen Einleitungssatz für einen Unfallbericht: *Freitag, 14. November, 07:45 Uhr, Kreuzung Bahnhofstraße/Schulweg, Zusammenstoß zwischen 12-jährigem Radfahrer und PKW*.",
          "concept": "Bericht: Einleitung (Wer, Was, Wann, Wo); Hauptteil (Wie, Warum, Folgen); Präteritum (Plusquamperfekt bei Vorzeitigkeit); sachlich ohne Gefühle/Wertungen/wörtliche Rede; Einleitung: 'Am Freitag, den 14. November, ereignete sich gegen 07:45 Uhr an der Kreuzung Bahnhofstraße/Schulweg ein Verkehrsunfall, bei dem ein 12-jähriger Radfahrer mit einem PKW kollidierte.'",
          "sample_solution": "1. Die formalen und stilistischen Kriterien eines Berichts: - **1. Die 7 W-Fragen**:   * **Einleitung (Überblick über das Kerngeschehen)**:     - **Wer** war beteiligt? (Beteiligte Personen/Fahrzeuge)     - **Was** ist geschehen? (Art des Vorfalls/Unfalls)     - **Wann** geschah es? (Genaues Datum und Uhrzeit)     - **Wo** ist es passiert? (Genaue Ortsangabe/Kreuzung).   * **Hauptteil (Verlauf & Ursache)**:     - **Wie** lief der Unfall im Detail chronologisch ab?     - **Warum** kam es dazu? (Unfallursache, z. B. Missachtung der Vorfahrt).   * **Schluss (Ergebnis/Folgen)**:     - **Welche Folgen** entstanden? (Personenschäden, Sachschäden in Euro, polizeiliche Maßnahmen). - **2. Sprachlicher Stil**:   * Nüchtern, präzise, sachlich und absolut neutral.   * **Verboten**: Eigene Gefühle, emotionale Ausrufe (*'Schrecklicherweise...', 'Zum Glück...'*) oder erfundene Spannungsmomente.   * **Keine wörtliche Rede**: Keine Dialoge mit Anführungszeichen. - **3. Zeitformen (Tempora)**:   * **Grundtempus: Präteritum** (*'Der Radfahrer bog ab...'*, *'Der Autofahrer bremste...'*)   * **Vorzeitigkeit: Plusquamperfekt** (*'Nachdem der Fahrer zuvor beschleunigt hatte, übersah er...'*). 2. Mustergültiger Einleitungssatz: - *„Am Freitag, dem 14. November, ereignete sich gegen 07:45 Uhr an der Kreuzung Bahnhofstraße / Schulweg ein Verkehrsunfall, bei dem ein zwölfjähriger Radfahrer mit einem Personenkraftwagen zusammenstieß.“*"
        }
      ]
    },
    {
      "id": "01K4D6B0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4D6B0000000000000000A02",
      "namespace": "deutsch-texte",
      "slug": "vorgangsbeschreibung-rezept-bauanleitung-passiv-praesens",
      "title": "Die Vorgangsbeschreibung: Rezept, Spielanleitung und Versuchsbeschreibung (Präsens, Passiv / man-Form)",
      "domain": "schule/deutsch/texte",
      "reduction": "formal",
      "typical_age_min": 11.5,
      "prerequisites": [
        {
          "atom_id": "01K4D6B0000000000000000A01",
          "type": "hard",
          "rationale": "Sachliches Formulieren baut auf Berichtskompetenzen auf."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q188",
          "target_label": "Instruction",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 6,
          "subject": "deutsch",
          "topic_code": "lb1",
          "topic_title": "Texte schreiben – Informieren",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4D6B0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "In welcher Zeitform (Tempus) wird eine allgemeingültige Vorgangsbeschreibung (z. B. Kochrezept, Bastelanleitung) verfasst?",
          "concept": "Im Präsens (Gegenwart, da der Ablauf jederzeit wiederholbar ist)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Im Präsens (Gegenwart)",
              "Im Präteritum (Vergangenheit)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4D6B0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre die Struktur und Sprachmittel einer gelungenen Vorgangsbeschreibung: 1. Gliederung in Materialliste/Zutatenliste, Vorbereitung, Durchführung (Schritt-für-Schritt-Anleitung) und Endergebnis, 2. Tempus: Präsens, 3. Adressatenbezogene Formulierungen: Passiv (*'Die Schraube wird festgedreht'*), unpersönliche man-Form (*'Nun rührt man den Teig'*), Infinitiv-Konstruktionen (*'Teig glattrühren'*) oder höfliche Sie-Form, 4. Treffende Fachbegriffe und präzise temporale Satzverknüpfungen (*zunächst, anschließend, daraufhin, währenddessen, schließlich*).",
          "concept": "Vorgangsbeschreibung: Materialliste -> Schrittweise Durchführung -> Ergebnis; Präsens; Passiv/man-Form; treffende Verben und zeitliche Verbindungswörter (zuerst, danach, schließlich).",
          "sample_solution": "1. Der Aufbau einer Vorgangsbeschreibung: - **1. Material- / Zutatenübersicht (Vorbereitung)**:   * Vollständige Aufzählung aller benötigten Werkzeuge, Materialien oder Zutaten mit exakten Mengenangaben (z. B. *'250 g Mehl, 1 Kreuzschlitz-Schraubendreher'*). - **2. Chronologische Durchführung (Hauptteil)**:   * Lückenlose, schrittweise Anleitung in logischer Reihenfolge. Jeder Einzelschritt muss so präzise formuliert sein, dass der Leser den Vorgang ohne Vorkenntnisse fehlerfrei nachvollziehen kann. - **3. Überprüfung / Endergebnis (Schluss)**:   * Beschreibung des fertigen Zustands (z. B. *'Nach dem Abkühlen ist das Werkstück einsatzbereit'*). 2. Sprachliche Gestaltungsmittel: - **1. Verbindliches Tempus**: Immer das **Präsens**, weil die Anleitung eine allgemeingültige, jederzeit reproduzierbare Handlungsanweisung darstellt. - **2. Objektive Formulierungsformen**:   * **Vorgangspassiv**: *'Das Backblech wird mit Butter eingefettet.'*   * **Unpersönliche 'man'-Form**: *'Anschließend gibt man die Hefe hinzu.'*   * **Infinitiv-Stil**: *'Die Schrauben gleichmäßig anziehen.'* - **3. Präzise Verknüpfungswörter (Temporaladverbien)**:   * Vermeidung von monotonen Wiederholungen wie *'und dann...'*.   * Stattdessen abwechslungsreiche Konnektoren: *Zunächst, zu Beginn, im nächsten Schritt, parallel dazu, währenddessen, anschließend, nach circa 10 Minuten, abschließend, schließlich*. - **4. Exakte Fachterminologie & Mengenangaben**:   * Verwendung präziser Verben (*unterheben, anziehen, feilen, verlöten, abwiegen*) statt ungenauer Allerweltswörter (*machen, tun*)."
        }
      ]
    }
  ]
}
